(function () {
  'use strict';

  // The threshold is NOT written here. It is rendered into data-fs-threshold by
  // snippets/free-shipping-bar.liquid from the shop metafield, in the SHOP's
  // currency. Shopify.currency.rate converts it to whatever currency the visitor
  // is actually being quoted, because cart.total_price arrives in that currency:
  // comparing a presentment total against a bare number would mean reading 49 USD
  // as if it were 49 EUR and promising free shipping that checkout will not give.
  function shopRate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c && parseFloat(c.rate);
    return (r && isFinite(r) && r > 0) ? r : 1;
  }

  function activeCurrency() {
    var c = window.Shopify && window.Shopify.currency;
    return (c && c.active) || 'EUR';
  }

  // Label as Liquid rendered it (money filter, shop format). Falling back to our
  // own formatting keeps the bar honest if the attribute is ever missing.
  function thresholdLabel(bar) {
    var l = bar && bar.getAttribute('data-fs-label');
    return l || formatMoney(thresholdCents());
  }

  function thresholdCents() {
    var bar = document.querySelector('[data-fs-threshold]');
    var base = bar ? parseInt(bar.getAttribute('data-fs-threshold'), 10) : NaN;
    if (!isFinite(base)) base = 4900;
    return Math.round(base * shopRate());
  }

  // Free shipping is an AUTOMATIC DISCOUNT ("Free shipping on all orders above
  // EUR49") applied to the shipping line at checkout, not a rate in the shipping
  // profile. Do NOT measure it with /cart/shipping_rates.json: that endpoint
  // returns profile rates BEFORE automatic discounts, which is what made the
  // 2026-08-30 pass wrongly conclude Germany was excluded.
  //
  // Verified 2026-09-04 against 1,448 real orders since 2026-03-01: of the 278
  // with a subtotal at or above 49 EUR, 272 shipped free. Germany got it on 5 of
  // 5 (#3176, #3025, #3701, #2646, #2741). Canada got it on 0 of 24, paying
  // 16.11 EUR on average, so Canada is the only true exclusion.
  var NO_FREE_SHIPPING = ['CA'];

  // The banner is a link to the picks page. These two strings must stay in sync
  // with snippets/free-shipping-bar.liquid: this file rewrites the bar's inner
  // markup on every cart change, so a CTA that only lives in Liquid disappears
  // the moment someone adds an item.
  var CTA_EMPTY_HTML = '<span class="fs-bar__cta">Get free shipping<span class="fs-bar__cta-arrow" aria-hidden="true">&rarr;</span></span>';
  /* Incrustada en la barra de promocion: comparte linea con el mensaje de la
     promo, asi que ni frase larga ni CTA propio. El Liquid pinta lo mismo. */
  var isInline = function (bar) { return bar.classList.contains('fs-bar--inline'); };
  var CTA_ACTIVE_HTML = '<span class="fs-bar__cta fs-bar__cta--inline">Close the gap<span class="fs-bar__cta-arrow" aria-hidden="true">&rarr;</span></span>';

  // ---------------------------------------------------------------------------
  // TEMA CHRISTMAS. Todo lo de aqui abajo solo corre si el Liquid puso
  // data-fs-theme="christmas" en la barra, que solo pasa mientras corre una
  // promocion navidena. Sin eso, ni una linea de esto se ejecuta.
  // ---------------------------------------------------------------------------

  // Esta cadena esta DUPLICADA en snippets/free-shipping-bar.liquid (fs_garland).
  // Mismo motivo que los dos CTA de arriba: este fichero reescribe el interior
  // de la barra en cada cambio del carrito, asi que una guirnalda que solo
  // viviera en el Liquid desapareceria al anadir el primer libro.
  var GARLAND_HTML = '<span class="fs-xmas-garland" aria-hidden="true"><svg viewBox="0 0 100 16" preserveAspectRatio="none" focusable="false"><path d="M0 4 Q25 13 50 7 Q75 1 100 9" stroke="#1f6b3f" stroke-width="2.6" fill="none" stroke-linecap="round" vector-effect="non-scaling-stroke"/></svg><i class="fs-xmas-bauble" data-fs-bauble="25" style="left:25%;top:58%"></i><i class="fs-xmas-bauble" data-fs-bauble="50" style="left:50%;top:44%"></i><i class="fs-xmas-bauble" data-fs-bauble="75" style="left:75%;top:28%"></i><i class="fs-xmas-bauble" data-fs-bauble="100" style="left:100%;top:56%"></i></span>';

  var FLAKE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 1.5v21M3 6.8l18 10.4M21 6.8L3 17.2"/><path d="M12 5.6 9.4 3M12 5.6 14.6 3M12 18.4 9.4 21M12 18.4l2.6 2.6"/><path d="M6.6 8.9 5.2 5.6M6.6 8.9 3.3 10.3M17.4 15.1l1.4 3.3M17.4 15.1l3.3 1.4M17.4 8.9l3.3-1.4M17.4 8.9l1.4-3.3M6.6 15.1 3.3 13.7M6.6 15.1l-1.4 3.3"/></svg>';
  var STAR_SVG  = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 2l1.7 6.6L20 10.4l-5.4 3.1.9 6.5-3.5-3.2-3.5 3.2.9-6.5L4 10.4l6.3-1.8z"/></svg>';

  function isXmas(bar) {
    return !!bar && bar.getAttribute('data-fs-theme') === 'christmas';
  }

  // Quien pide menos movimiento se queda el tema puesto y sin nada que se mueva.
  // Se consulta en cada uso y no se cachea: el ajuste se puede cambiar con la
  // pagina abierta.
  function stillPlease() {
    try {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { return false; }
  }

  function canAnimate(el) {
    return !!el && typeof el.animate === 'function' && !stillPlease();
  }

  function makeFlake(size, gold) {
    var f = document.createElement('span');
    f.className = 'fs-xmas-flake' + (gold ? ' fs-xmas-flake--gold' : '');
    f.style.width = size + 'px';
    f.style.height = size + 'px';
    f.innerHTML = gold ? STAR_SVG : FLAKE_SVG;
    return f;
  }

  // Nieve de fondo. Se monta una sola vez por barra y la mueve el CSS, para no
  // dejar un requestAnimationFrame abierto toda la sesion por decoracion.
  function mountAmbientSnow(bar) {
    var host = bar.querySelector('[data-fs-snow]');
    if (!host || host.dataset.fsAmbient === '1' || stillPlease()) return;
    host.dataset.fsAmbient = '1';
    var layer = document.createElement('span');
    layer.className = 'fs-xmas-snow fs-xmas-snow--ambient';
    var h = Math.max(bar.offsetHeight, 46);
    for (var i = 0; i < 9; i++) {
      var size = 5 + Math.random() * 5;
      var f = makeFlake(size, false);
      f.style.left = (Math.random() * 96) + '%';
      f.style.setProperty('--fs-dur', (9 + Math.random() * 7) + 's');
      f.style.setProperty('--fs-del', (-Math.random() * 16) + 's');
      f.style.setProperty('--fs-sx', (6 + Math.random() * 16) + 'px');
      f.style.setProperty('--fs-h', (h + 20) + 'px');
      f.style.setProperty('--fs-o', (0.35 + Math.random() * 0.3).toFixed(2));
      layer.appendChild(f);
    }
    host.appendChild(layer);
  }

  // Rafaga en la punta del relleno: el libro que acaba de entrar revienta en
  // copos justo donde ha empujado la barra.
  function burstAtTip(bar) {
    var host = bar.querySelector('[data-fs-snow]');
    var fill = bar.querySelector('[data-fs-fill]');
    if (!host || !fill || stillPlease()) return;
    var box = bar.getBoundingClientRect();
    var tip = fill.getBoundingClientRect();
    if (!tip.width && !tip.height) return;
    var x = tip.right - box.left;
    var y = tip.top + tip.height / 2 - box.top;

    for (var i = 0; i < 16; i++) {
      var size = 6 + Math.random() * 7;
      var f = makeFlake(size, Math.random() < 0.45);
      f.style.left = (x - size / 2) + 'px';
      f.style.top = (y - size / 2) + 'px';
      host.appendChild(f);
      if (!canAnimate(f)) { f.remove(); continue; }
      var ang = Math.random() * Math.PI * 2;
      var dist = 22 + Math.random() * 58;
      var dx = Math.cos(ang) * dist;
      var dy = Math.sin(ang) * dist * 0.62;
      (function (el) {
        var a = el.animate([
          { transform: 'translate(0,0) scale(0.2) rotate(0deg)', opacity: 0 },
          { transform: 'translate(' + (dx * 0.6) + 'px,' + (dy * 0.6) + 'px) scale(1) rotate(90deg)', opacity: 1, offset: 0.35 },
          { transform: 'translate(' + dx + 'px,' + (dy + 16) + 'px) scale(0.5) rotate(260deg)', opacity: 0 }
        ], { duration: 700 + Math.random() * 420, easing: 'cubic-bezier(0.2,0.7,0.3,1)' });
        a.finished.then(function () { el.remove(); }).catch(function () { el.remove(); });
      })(f);
    }

    var ring = document.createElement('span');
    ring.className = 'fs-xmas-ring';
    ring.style.left = (x - 6) + 'px';
    ring.style.top = (y - 6) + 'px';
    ring.style.width = '12px';
    ring.style.height = '12px';
    host.appendChild(ring);
    if (!canAnimate(ring)) { ring.remove(); return; }
    ring.animate([
      { transform: 'scale(0.4)', opacity: 0.95 },
      { transform: 'scale(6)', opacity: 0 }
    ], { duration: 620, easing: 'cubic-bezier(0.1,0.8,0.2,1)' })
      .finished.then(function () { ring.remove(); }).catch(function () { ring.remove(); });
  }

  // Enciende una bola por cada cuarto del camino. El pop solo salta en la bola
  // que acaba de encenderse, no en las que ya estaban. El color va en el style
  // y no en una clase: ver por que en el comentario del CSS.
  function updateBaubles(bar, progress) {
    var baubles = bar.querySelectorAll('[data-fs-bauble]');
    for (var i = 0; i < baubles.length; i++) {
      var c = baubles[i];
      var on = progress >= parseInt(c.getAttribute('data-fs-bauble'), 10) - 0.01;
      var was = c.classList.contains('is-on');
      if (on === was) continue;
      c.classList.toggle('is-on', on);
      // Rojo y oro alternos, como las bolas de las portadas de la linea.
      c.style.background = on ? (i % 2 ? '#f5c86b' : '#e0483c') : '';
      c.style.boxShadow = on ? (i % 2 ? '0 0 7px rgba(245,200,107,0.6)' : '0 0 7px rgba(224,72,60,0.5)') : '';
      if (on) {
        // Reinicia el pop aunque la bola ya lo hubiera corrido antes.
        c.style.animation = 'none';
        void c.offsetWidth;
        c.style.animation = '';
      }
    }
  }

  // El barrido de oro y las bolas parpadeando en cadena, al cruzar los 49.
  function xmasCelebrate(bar) {
    if (stillPlease()) return;
    var sweep = bar.querySelector('[data-fs-sweep]');
    if (canAnimate(sweep)) {
      sweep.animate([
        { transform: 'translateX(-110%)' },
        { transform: 'translateX(110%)' }
      ], { duration: 1100, easing: 'cubic-bezier(0.3,0,0.4,1)' });
    }
    var baubles = bar.querySelectorAll('[data-fs-bauble]');
    for (var i = 0; i < baubles.length; i++) {
      (function (c, delay) {
        setTimeout(function () {
          c.classList.add('is-twinkle');
          setTimeout(function () { c.classList.remove('is-twinkle'); }, 1900);
        }, delay);
      })(baubles[i], 140 * i);
    }
  }

  // Studio endpoint that counts bar impressions and clicks. Fire and forget:
  // it must never delay or block the navigation the click starts.
  var STUDIO_EVENTS = 'https://studio.digitalpolyglot.com/api/fsbar/event';

  function sendEvent(type, extra) {
    var payload = { type: type, path: location.pathname, ts: Date.now() };
    if (extra) { for (var k in extra) if (extra.hasOwnProperty(k)) payload[k] = extra[k]; }
    try {
      // text/plain keeps sendBeacon a simple request, so no CORS preflight.
      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
      if (navigator.sendBeacon && navigator.sendBeacon(STUDIO_EVENTS, blob)) return;
    } catch (e) { /* falls through to fetch */ }
    try {
      fetch(STUDIO_EVENTS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    } catch (e) { /* never break the page over a metric */ }
  }

  function destinationHasFreeShipping() {
    var c = (window.Shopify && window.Shopify.country) || '';
    return NO_FREE_SHIPPING.indexOf(c) === -1;
  }

  function hideBars() {
    var bars = document.querySelectorAll('[data-fs-bar]');
    for (var i = 0; i < bars.length; i++) bars[i].style.display = 'none';
  }

  // Money written the way the rest of the page writes it. Liquid hands us
  // 1234.56 already formatted in data-fs-sample, so the symbol, its side and
  // both separators are read off that instead of being guessed from the page
  // language, which produced 29.01 next to Liquid's 29,01.
  function moneyShape() {
    var bar = document.querySelector('[data-fs-sample]');
    var sample = bar && bar.getAttribute('data-fs-sample');
    var m = sample && sample.match(/^(\D*)[\d]{1}(\D?)\d{3}(\D)(\d{2})(\D*)$/);
    if (!m) return null;
    return { prefix: m[1], group: m[2], decimal: m[3], suffix: m[5] };
  }

  var SHAPE = null;

  function formatMoney(cents) {
    if (SHAPE === null) SHAPE = moneyShape() || false;
    var amount = Math.abs(cents) / 100;
    if (!SHAPE) return amount.toFixed(2) + ' ' + activeCurrency();
    var whole = Math.floor(amount);
    var frac = Math.round((amount - whole) * 100);
    var groups = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, SHAPE.group);
    return SHAPE.prefix + groups + SHAPE.decimal + (frac < 10 ? '0' + frac : frac) + SHAPE.suffix;
  }

  // Interpolate color from red -> orange -> yellow -> green based on progress 0-100
  function getBarColor(progress) {
    var r, g, b;
    if (progress < 33) {
      // Red to Orange
      var t = progress / 33;
      r = 220;
      g = Math.round(50 + t * 120);
      b = Math.round(30 + t * 10);
    } else if (progress < 66) {
      // Orange to Yellow
      var t = (progress - 33) / 33;
      r = Math.round(220 + t * 35);
      g = Math.round(170 + t * 60);
      b = Math.round(40 - t * 10);
    } else {
      // Yellow to Green
      var t = (progress - 66) / 34;
      r = Math.round(255 - t * 209);
      g = Math.round(230 - t * 26);
      b = Math.round(30 + t * 83);
    }
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  function getGlowColor(progress) {
    var r, g, b;
    if (progress < 33) {
      r = 220; g = 50; b = 30;
    } else if (progress < 66) {
      r = 255; g = 180; b = 30;
    } else {
      r = 46; g = 204; b = 113;
    }
    return 'rgba(' + r + ',' + g + ',' + b + ',';
  }

  function updateBars(cartTotal, itemCount) {
    var bars = document.querySelectorAll('[data-fs-bar]');
    if (!bars.length) return;

    // Do not advertise a threshold the destination can never reach.
    if (!destinationHasFreeShipping()) {
      hideBars();
      return;
    }

    var threshold = thresholdCents();
    var remaining = threshold - cartTotal;
    var progress = Math.min((cartTotal / threshold) * 100, 100);
    var state = remaining <= 0 ? 'success' : 'default';
    var intensity = progress >= 80 && state !== 'success' ? 'high' : 'normal';

    // Build message
    var message = '';
    if (remaining <= 0) {
      message = "You've unlocked <strong>free shipping!</strong> &#127881;";
    } else if (progress >= 80) {
      message = "Almost there! Just <strong>" + formatMoney(remaining) + "</strong> away from <strong>free shipping!</strong>";
    } else {
      message = "You're <strong>" + formatMoney(remaining) + "</strong> away from <strong>free shipping</strong>";
    }
    var messageInline = remaining <= 0
      ? "<strong>Free shipping</strong> unlocked"
      : "<strong>" + formatMoney(remaining) + "</strong> to <strong>free shipping</strong>";

    // Dynamic colors
    var barColor = state === 'success'
      ? 'linear-gradient(90deg, #27ae60, #2ecc71, #27ae60)'
      : 'linear-gradient(90deg, ' + getBarColor(Math.max(progress - 10, 0)) + ', ' + getBarColor(progress) + ')';

    var glowBase = getGlowColor(progress);
    var stripeSpeed = intensity === 'high' ? '0.4s' : (1.2 - progress * 0.008) + 's';

    bars.forEach(function (bar) {
      bar.setAttribute('data-fs-state', state);
      bar.setAttribute('data-fs-intensity', intensity);

      var isBanner = bar.classList.contains('fs-bar--banner');

      // Banner: transition between empty and active states
      if (isBanner) {
        if (itemCount > 0) {
          bar.classList.remove('fs-bar--empty');

          // Ensure track + fill exist (may need to rebuild from static state)
          var track = bar.querySelector('.fs-bar__track');
          if (!track) {
            var content = bar.querySelector('.fs-bar__content');
            if (content) {
              content.innerHTML =
                (isXmas(bar) ? GARLAND_HTML : '') +
                '<div class="fs-bar__track"><div class="fs-bar__fill" data-fs-fill></div></div>' +
                '<p class="fs-bar__message"></p>' +
                (isInline(bar) ? '' : CTA_ACTIVE_HTML);
            }
          }
        } else {
          bar.classList.add('fs-bar--empty');
          var content = bar.querySelector('.fs-bar__content');
          if (content) {
            content.innerHTML = '<p class="fs-bar__message fs-bar__message--static"><span class="fs-static__icon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg></span> <span class="fs-static__label">' + (isInline(bar) ? 'Free shipping over' : 'FREE SHIPPING on orders over') + '</span> <span class="fs-static__amount">' + thresholdLabel(bar) + '</span> ' + (isInline(bar) ? '' : CTA_EMPTY_HTML) + '</p>';
          }
          return;
        }
      } else {
        // Cart location: show/hide
        if (itemCount > 0) {
          bar.classList.remove('fs-bar--hidden');
        } else {
          bar.classList.add('fs-bar--hidden');
          return;
        }
      }

      // La celebracion (confeti + entrada del texto) solo la primera vez que el
      // carrito cruza el umbral en esta sesion. Antes se repetia en cada
      // pagina y en cada recarga, porque el flag vivia en memoria. Si el
      // carrito baja del umbral y vuelve a cruzarlo, se celebra otra vez: eso
      // si es "cuando pasa". sessionStorage puede no estar (modo privado):
      // en ese caso se comporta como antes.
      var celebrated = false;
      try { celebrated = sessionStorage.getItem('dp_fs_celebrated') === '1'; } catch (e) {}
      var msgEl = bar.querySelector('.fs-bar__message');
      if (msgEl) {
        msgEl.className = 'fs-bar__message';
        if (state === 'success') {
          msgEl.classList.add('fs-bar__message--success');
          if (celebrated) msgEl.classList.add('fs-bar__message--quiet');
        }
        msgEl.innerHTML = isInline(bar) ? messageInline : message;
      }

      var fill = bar.querySelector('[data-fs-fill]');
      if (fill) {
        if (state === 'success') {
          fill.style.width = '100%';
          fill.style.background = 'linear-gradient(90deg, #27ae60, #2ecc71, #58d68d, #2ecc71, #27ae60)';
          fill.style.backgroundSize = '200% 100%';
          fill.style.boxShadow = '0 0 16px rgba(46,204,113,0.7), 0 0 32px rgba(46,204,113,0.3)';
        } else {
          fill.style.width = progress + '%';
          fill.style.background = barColor;
          fill.style.backgroundSize = '';
          fill.style.boxShadow = '';
        }
        fill.style.setProperty('--fs-glow', glowBase + '0.5)');
        fill.style.setProperty('--fs-stripe-speed', stripeSpeed);

        // Add or keep spark element
        var spark = fill.querySelector('.fs-bar__spark');
        if (progress > 0 && state !== 'success') {
          if (!spark) {
            spark = document.createElement('span');
            spark.className = 'fs-bar__spark';
            fill.appendChild(spark);
          }
        } else if (spark) {
          spark.remove();
        }
      }

      // Lo navideno: el relleno en oro, las bolas de la guirnalda y la rafaga
      // de copos en la punta. El verde de success sobre el pino se pierde
      // (son el mismo color), asi que al cruzar el umbral manda el oro.
      if (isXmas(bar)) {
        if (fill && state === 'success') {
          fill.style.background = 'linear-gradient(90deg, #b5832c, #f5c86b, #fff3d4, #f5c86b, #b5832c)';
          fill.style.boxShadow = '0 0 16px rgba(245,200,107,0.7), 0 0 32px rgba(245,200,107,0.3)';
        }
        if (fill && state !== 'success') {
          fill.style.setProperty('--fs-glow', 'rgba(245,200,107,0.5)');
        }
        updateBaubles(bar, state === 'success' ? 100 : progress);
        mountAmbientSnow(bar);
        // La rafaga solo cuando el carrito SUBE. En la primera pasada
        // (_fsPrev sin definir) no salta: entrar a la tienda con el carrito ya
        // lleno no es un evento, y reventaria copos en cada carga de pagina.
        if (typeof bar._fsPrev === 'number' && progress > bar._fsPrev + 0.01) {
          burstAtTip(bar);
        }
        bar._fsPrev = progress;
      }

      // Confetti on success: una vez por cruce del umbral, no por carga.
      if (state === 'success') {
        if (!bar._confettiDone && !celebrated) {
          bar._confettiDone = true;
          try { sessionStorage.setItem('dp_fs_celebrated', '1'); } catch (e) {}
          launchConfetti(bar);
          if (isXmas(bar)) xmasCelebrate(bar);
        }
      } else {
        bar._confettiDone = false;
        try { sessionStorage.removeItem('dp_fs_celebrated'); } catch (e) {}
      }
    });
  }

  // Confetti particle system
  function launchConfetti(bar) {
    var canvas = bar.querySelector('.fs-bar__confetti');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.className = 'fs-bar__confetti';
      bar.style.position = 'relative';
      bar.appendChild(canvas);
    }

    var ctx = canvas.getContext('2d');
    canvas.width = bar.offsetWidth;
    canvas.height = bar.offsetHeight;

    // En Navidad no es confeti de fiesta: es nieve. Cae desde arriba en vez de
    // saltar desde abajo, y va en el oro y el crema de las portadas de la
    // linea, porque el verde de la casa sobre el pino no se ve.
    var xmas = isXmas(bar);
    var colors = xmas
      ? ['#f5c86b','#fff3d4','#b5832c','#ffffff','#f6d78a']
      : ['#2ecc71','#27ae60','#f1c40f','#ff9f1c','#fff','#58d68d','#e74c3c','#3498db'];
    var particles = [];
    var totalParticles = 60;

    for (var i = 0; i < totalParticles; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: xmas ? -(Math.random() * 14 + 4) : canvas.height + Math.random() * 10,
        vx: xmas ? (Math.random() - 0.5) * 1.4 : (Math.random() - 0.5) * 4,
        vy: xmas ? (Math.random() * 0.9 + 0.5) : -(Math.random() * 4 + 2),
        size: xmas ? (Math.random() * 4 + 2) : (Math.random() * 5 + 2),
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        rotSpeed: xmas ? (Math.random() - 0.5) * 5 : (Math.random() - 0.5) * 10,
        gravity: xmas ? 0.004 + Math.random() * 0.006 : 0.06 + Math.random() * 0.04,
        opacity: 1,
        shape: xmas ? 'circle' : (Math.random() > 0.5 ? 'rect' : 'circle')
      });
    }

    var frame = 0;
    var maxFrames = 120;

    function animate() {
      if (frame > maxFrames) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.remove();
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(function(p) {
        p.x += p.vx;
        p.vy += p.gravity;
        p.y += p.vy;
        p.rotation += p.rotSpeed;
        if (frame > maxFrames * 0.6) {
          p.opacity = Math.max(0, p.opacity - 0.03);
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation * Math.PI / 180);
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;

        if (p.shape === 'rect') {
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      });

      frame++;
      requestAnimationFrame(animate);
    }

    animate();
  }

  function fetchCart() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBars(cart.total_price, cart.item_count);
        // This file already sees every cart mutation on the site, so it is the
        // one place that can tell the rest of the page. The header bag count
        // listens for this; without it an AJAX add left the number stale until
        // the next full page load.
        try {
          document.dispatchEvent(new CustomEvent('dp:cart:updated', { detail: cart }));
        } catch (e) { /* older browsers: the header can still refresh itself */ }
      })
      .catch(function () {});
  }

  // Intercept fetch-based cart changes
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    return originalFetch.apply(this, args).then(function (response) {
      if (/\/cart\/(add|update|change|clear)/.test(url)) {
        setTimeout(fetchCart, 300);
      }
      return response;
    });
  };

  // Intercept XMLHttpRequest
  var originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._fsUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  var originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener('load', function () {
      if (self._fsUrl && /\/cart\/(add|update|change|clear)/.test(self._fsUrl)) {
        setTimeout(fetchCart, 300);
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  // Move bar inside Dawn's sticky-header so it sticks with the nav
  function attachToStickyHeader() {
    var bar = document.querySelector('.fs-bar--banner');
    var stickyHeader = document.querySelector('sticky-header');
    if (bar && stickyHeader && bar.parentElement !== stickyHeader) {
      stickyHeader.insertBefore(bar, stickyHeader.firstChild);
    }
  }

  // Initialize
  function bindBarTracking() {
    var links = document.querySelectorAll('[data-fs-link]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].dataset.fsTracked === '1') continue;
      links[i].dataset.fsTracked = '1';
      sendEvent('bar_view');
      links[i].addEventListener('click', function () {
        sendEvent('bar_click');
        if (window.dataLayer) window.dataLayer.push({ event: 'dp_fsbar_click' });
      });
    }
  }

  function init() {
    attachToStickyHeader();
    bindBarTracking();
    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
